import { Routes } from '@angular/router';
import { pendingChangesGuard } from '../../../core/guards/pending-changes.guard';
import { wizardStep2Guard, wizardStep3Guard, wizardStep4Guard, unsavedChangesGuard } from './wizard.guard';

export const roteirizacaoWizardRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./step-configurar/configurar-roteiro.component')
      .then(m => m.ConfigurarRoteiroComponent),
    canDeactivate: [unsavedChangesGuard]
  },
  {
    path: 'revisar-cidades',
    loadComponent: () => import('./step-revisar/revisar-cidades.component')
      .then(m => m.RevisarCidadesComponent),
    canActivate: [wizardStep2Guard],
    canDeactivate: [unsavedChangesGuard]
  },
  {
    path: 'visualizar-rotas',
    loadComponent: () => import('./step-visualizar/visualizar-rotas.component')
      .then(m => m.VisualizarRotasComponent),
    canActivate: [wizardStep3Guard],
    canDeactivate: [pendingChangesGuard]
  },
  {
    path: 'mapa-detalhes',
    loadComponent: () => import('./step-mapa/mapa-detalhes.component')
      .then(m => m.MapaDetalhesComponent),
    canActivate: [wizardStep4Guard]
  }
];
